module.exports = __webpack_public_path__ + "static/media/restaurant-not-found.fe987ac0.svg";